import { render, staticRenderFns } from "./PricingFeatures.vue?vue&type=template&id=1969e3fe&scoped=true&"
import script from "./PricingFeatures.vue?vue&type=script&lang=js&"
export * from "./PricingFeatures.vue?vue&type=script&lang=js&"
import style0 from "./PricingFeatures.vue?vue&type=style&index=0&id=1969e3fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1969e3fe",
  null
  
)

export default component.exports